/**
 * Accepts only same-origin relative paths for post-login redirects (prevents open redirects such
 * as `//evil.example` or `https://…`).
 */
export function safeNextPath(raw: string | null | undefined, fallback = '/'): string {
  if (raw === null || raw === undefined || raw === '') {
    return fallback;
  }
  if (!raw.startsWith('/') || raw.startsWith('//') || raw.startsWith('/\\')) {
    return fallback;
  }
  let hasControlCharacter = false;
  for (let index = 0; index < raw.length; index += 1) {
    if (raw.charCodeAt(index) < 0x20) {
      hasControlCharacter = true;
    }
  }
  if (hasControlCharacter || raw.startsWith('/login')) {
    return fallback;
  }
  return raw;
}

export function loginPathFor(next: string): string {
  return `/login?next=${encodeURIComponent(next)}`;
}

/** Reads `token` from a URL fragment such as `#token=abc` (email links keep tokens out of logs). */
export function tokenFromHash(hash: string): string | null {
  const fragment = hash.startsWith('#') ? hash.slice(1) : hash;
  const token = new URLSearchParams(fragment).get('token');
  return token === null || token === '' ? null : token;
}
